import { toTime } from '@housekeep/infra';

// The default window of hours to represent a worker's availability
export const DEFAULT_DAY_START = toTime('07:00:00');
export const DEFAULT_DAY_END = toTime('22:00:00');
